import React from "react";
import {
    NavLink
} from "react-router-dom";
import config from "./../../config.js";
class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        let user = {};
        let uistyle = {};
        if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
            user = JSON.parse(localStorage.user);
            if (typeof user.company.type !== 'undefined' && user.company.type !== '') {
                uistyle = JSON.parse(user.company.type);
            }
        }
        this.state = {
            user: user,
            uistyle: uistyle
        }
    }
    render() {
        const {
            user,
            uistyle
        } = this.state;
        const links = {
            download_encrypted: config.union + '/data/software/FileEncrypterInstall.zip',
            download_batchupload: config.union + '/data/software/PD_BatchUploader.zip',
            download_batchuploader: config.union + '/data/software/SSW_BatchUploader.zip',
            BLBatchUploaderSetUp: config.union + '/data/software/BLBatchUploaderSetUp.zip'
        };
        return (
            <nav className="col-2 d-none d-block sidebar">
                <div className="sidebar-sticky shadow">
                    <div className="nav flex-column">
                        <h6 className="sidebar-heading px-3 mt-4 mb-1">管理列表</h6>

                        <NavLink className="nav-item nav-link " to="/console" exact> <i className="fa fa-dashboard fa-tachometer-alt"></i> 摘要 </NavLink>

                        <NavLink className={`nav-item nav-link`} to={`/console/list_subjects/0/0`} > <i className="fa fa-list-alt"></i> 受试者管理 </NavLink>

                        <NavLink className={`nav-item nav-link`} to={`/console/list_service/0/brainlabel`}  > <i className="fa fa-brain"></i> 全脑分割</NavLink>

                        {uistyle.is_pet && <NavLink className={`nav-item nav-link`} to={`/console/list_service/0/pet`}  > <i className="fa fa-braille"></i> PET分析</NavLink>}

                        {uistyle.is_project &&
                            <NavLink className="nav-item nav-link" to={`/console/myprojects`} exact> <i className="fa fa-project-diagram"></i> 我的项目</NavLink>
                        }

                        <NavLink className="nav-item nav-link" to={`/console/list_prototype`} exact> <i className="fa fa-pencil-ruler"></i> 序列规则 </NavLink>

                        <NavLink className="nav-item nav-link" to={`/console/list_tags`} exact> <i className="fa fa-tags"></i> 标签设置 </NavLink>



                        <h6 className="sidebar-heading px-3 mt-4 mb-1 font-weight-light">下载</h6>

                        <a className="nav-item nav-link" href={links.download_encrypted}><i className="fa fa-lock"></i> 加密工具</a>

                        {uistyle.is_project && (user.company_id == 3 || user.company_id == 4) &&
                            <a className="nav-item nav-link" href={links.download_batchupload}><i className="fa fa-upload"></i> 批量上传工具</a>}

                        {user.company_id == 1 &&
                            <a className="nav-item nav-link" href={links.BLBatchUploaderSetUp}><i className="fa fa-upload"></i> 批量上传工具</a>}



                        {/* 
                        {user.company_id == 5 && <a className="nav-item nav-link" href={links.download_batchuploader}><i className="fa fa-upload"></i> 批量上传工具</a>} */}


                        <NavLink className="nav-item nav-link" to={`/console/browsers`} > <i className="fa fa-file-download"></i> 浏览器下载</NavLink>

                        <h6 className="sidebar-heading px-3 mt-4 mb-1 font-weight-light">服务</h6>
                        <NavLink className="nav-item nav-link " to="/console/service_introduction" exact><i className="fa fa-align-center"></i> 服务介绍</NavLink>

                        <NavLink className="nav-item nav-link " to={'/console/declaration'}><i className="fa fa-bullhorn"></i> 使用声明</NavLink>

                        {
                            this.state.user.level < 2 &&
                            <div>
                                <h6 className="sidebar-heading px-3 mt-4 mb-1 font-weight-light">管理员</h6>
                                <NavLink className="nav-item nav-link " to="/console/manager/list_data" exact><i className="fa fa-database"></i> 数据列表</NavLink>
                                <NavLink className="nav-item nav-link " to="/console/manager/list_user" exact><i className="fa fa-address-book"></i> 用户管理</NavLink>
                                <NavLink className="nav-item nav-link " to="/console/manager/config_site" exact><i className="fa fa-flag"></i> 网站管理</NavLink>

                            </div>
                        }

                        <h6 className="sidebar-heading px-3 mt-4 mb-1 font-weight-light" style={{ display: this.props.partstyle ? 'none' : 'block' }}>个人信息</h6>
                        <NavLink className="nav-item nav-link" to={`/console/user/user_profile`} style={{ display: this.props.partstyle ? 'none' : 'block' }}> <i className="fa fa-street-view"></i> 个人资料</NavLink>
                        <NavLink className="nav-item nav-link" to={`/console/user/reset_password`} style={{ display: this.props.partstyle ? 'none' : 'block' }}> <i className="fa fa-unlock-alt"></i> 修改密码</NavLink>


                    </div>


                </div>
            </nav>
        );
    }
}

export default Sidebar


// WEBPACK FOOTER //
// ./src/apps/console/common/sidebar.js